import { MIN_MILES_FOR_REFERRAL_CODE } from '@src/constants/miles'

export function shouldDisplayReferralCode(miles: number) {
    // shareable referral codes appear only after 10,000 miles
    return miles > MIN_MILES_FOR_REFERRAL_CODE
}
